import {
    CardHeader,
    CardContent,
    Typography,
  } from "@mui/material";
  import { useParams } from "react-router-dom";
  import CreatePMI from "./CreatePMI";
  
  const AddPMI = () => {
    const { PMIId } = useParams();
    const isEdit = PMIId === undefined ? false : true;
    return (
      <>
          <CardHeader
            avatar={
              <Typography>
               <h2>{PMIId === undefined ? "Add PMI" : "Edit PMI"}</h2>
              </Typography>
            }
          />
          <CardContent>
            <CreatePMI PMIId={PMIId} isEdit={isEdit}/>
          </CardContent>
  
      </>
    );
  };
  
  export default AddPMI;
  